import Joi from "joi-browser";
import env from "./env";

const envVarsSchema = Joi.object({
  REACT_APP_PROXY: Joi.string().uri().required(),
  REACT_APP_ENGINE: Joi.string().uri().required(),
  NODE_ENV: Joi.string().required(),
})
  .unknown()
  .required();

const { error, value: envVars } = envVarsSchema.validate(env);
if (error) {
  throw new Error(`Config validation error: ${error.message}`);
}

const config = {
  proxy: envVars.REACT_APP_PROXY,
  engine: envVars.REACT_APP_ENGINE,
  env: envVars.NODE_ENV,
};

console.log("Config", config);

export default config;
